import { Component, OnInit } from '@angular/core';
import { CstemapiService } from '../cstemapi.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { charts } from 'highcharts';
import * as $ from 'jquery';

declare var Highcharts: any;

@Component({
  selector: 'app-outputfinancial',
  templateUrl: './outputfinancial.component.html',
  styleUrls: ['./outputfinancial.component.scss']
})
export class OutputfinancialComponent implements OnInit {
  baseSummary: any;
  subsidy: any;
  yearmetricsDataset: any = [];
  yearmetricsDataset1: any = [];
  chooseOptions: any;
  yearDataset = [];
  chart1: any;
  diff: any;
  yearon: any;
  yearMetricsValue: any = [];
  yearMetricsPercent: any = [];
  yearChart: any; yearChart1: any;
  netSalable: any = {}; saleofEnergy: any = {}; ebidta: any = {}; pat: any = {}; dscr: any = {};
  netSalable_ws: any = {}; saleofEnergy_ws: any = {}; ebidta_ws: any = {}; pat_ws: any = {}; dscr_ws: any = {};
  netSalable_bf: any = {}; saleofEnergy_bf: any = {}; ebidta_bf: any = {}; pat_bf: any = {}; dscr_bf: any = {};
  fmode: any;
  sheader: any;
  isCollapsed; isCollapsed1; isCollapsed2;
  basecase = true; basecase_ws: any; bidfitcase: any;

  constructor(private cstemapi: CstemapiService, private myRoute: Router, private auth: AuthService) {
    this.chooseOptions = this.auth.getCaseDetails();
    // console.log(this.chooseOptions)

    this.fmode = 'lwos';
    this.basecase = true;

    this.getYearMetrics_base('netSaleableEnergyMU');
    this.getYearMetrics_base('netSaleOfEnergy');
    this.getYearMetrics_base('dscr');

    if (this.chooseOptions.financialModelTypeCode == 'bid') {
      this.getYearMetrics_bidfit('netSaleableEnergyMU', 'bidMode');
      this.getYearMetrics_bidfit('netSaleOfEnergy', 'bidMode');
      this.getYearMetrics_bidfit('dscr', 'bidMode');
    }
    if (this.chooseOptions.financialModelTypeCode == 'fit') {
      this.getYearMetrics_bidfit('netSaleableEnergyMU', 'fitMode');
      this.getYearMetrics_bidfit('netSaleOfEnergy', 'fitMode');
      this.getYearMetrics_bidfit('dscr', 'fitMode');
    }
    if (this.chooseOptions.subsidised) {
      this.getYearMetrics_basews('netSaleableEnergyMU');
      this.getYearMetrics_basews('netSaleOfEnergy');
      this.getYearMetrics_basews('dscr');
    }
  }

  ngOnInit() {
    if (this.chooseOptions.subsidised) {
      this.subsidy = '1';
      if (this.chooseOptions.financialModelTypeCode == 'lcoe') {
        this.sheader = 'Subsidy Analysis';
      } else if (this.chooseOptions.financialModelTypeCode == 'bid') {
        this.sheader = 'Subsidy and Bid Analysis';
      } else {
        this.sheader = 'Subsidy and FIT Analysis';
      }
    } else {
      this.subsidy = '3';
      if (this.chooseOptions.financialModelTypeCode == 'bid') {
        this.sheader = 'Bid Analysis';
      } else if (this.chooseOptions.financialModelTypeCode == 'fit') {
        this.sheader = 'Feed in Tariff Analysis';
      } else {
        this.sheader = 'LCOE @ IRR Analysis';
      }
    }
    window.scroll(0, 0);
    let top = document.getElementById('summary');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }

    $(document).ready(function () {
      $('.sidelinks-sm').click(function () {
        $('.sidelinks').toggle();
      })
    })
  }

  ngAfterViewInit() {
    am4core.useTheme(am4themes_animated);

    this.getBaseCaseSummary();
    if (this.chooseOptions.financialModelTypeCode != 'lcoe' && !this.chooseOptions.subsidised) {
      this.subsidyChange();
    } else if (this.chooseOptions.subsidised) {
      this.subsidyChange();
    }

  }

  getBaseCaseSummary() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId()
    };
    var api = 'fReports/getBaseCaseSummary'
    this.cstemapi.cstemAPI(dObj).GetBaseCaseSummary.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.baseSummary = resData;
        this.capitalcostChart(resData.costBreakupResponse);
        this.lcoeChart(resData.lcoeBreakupResponse);
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting base case summary details', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  capitalcostChart(cdata) {
    // console.log(cdata)
    var data = [{
      name: 'Civil and General Works',
      y: cdata.civilAndGeneralWorks
    }, {
      name: 'Indirect Expenses',
      y: cdata.indirectExpenses
    }, {
      name: 'Land',
      y: cdata.land
    }, {
      name: 'Mounting Structure',
      y: cdata.mountingStructure
    }, {
      name: 'PCU / Inverter',
      y: cdata.pcu_inverter
    }, {
      name: 'Power Evacuation Infrastructure',
      y: cdata.powerEvacuationInfrastructure
    }, {
      name: 'PV Modules',
      y: cdata.pvModules
    }];

    if (this.chooseOptions.applicationTypeCode != 'util') {
      data.push({
        name: 'Battery',
        y: cdata.battery
      })
    }

    Highcharts.chart('fcapital', {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: ''
      },
      tooltip: {
        headerFormat: '<span style:"font-size: 14px">{point.key}: </span>',
        pointFormat: '<b>{point.y}</b>',
        style: this.cstemapi.h_x_y_tooltip_format
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
            style: {
              color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black',
              fontSize: '14px'
            }
          }
        }
      },
      series: [{
        name: 'Values',
        colorByPoint: true,
        data: data,
        tooltip: {
          valuePrefix: '₹ ',
          valueSuffix: ' Lakhs'
        }
      }]
    });
  }

  lcoeChart(ldata) {
    var data = [{
      name: 'Civil and General Works',
      data: [ldata.civilAndGeneralWorks]
    }, {
      name: 'Indirect Expenses',
      data: [ldata.indirectExpenses]
    }, {
      name: 'Land',
      data: [ldata.land]
    }, {
      name: 'Mounting Structure',
      data: [ldata.mountingStructure]
    }, {
      name: 'PCU / Inverter',
      data: [ldata.pcu_inverter]
    }, {
      name: 'Power Evacuation Infrastructure',
      data: [ldata.powerEvacuationInfrastructure]
    }, {
      name: 'PV Modules',
      data: [ldata.pvModules]
    }, {
      name: 'Expenses',
      data: [ldata.expences]
    }]
    if (this.chooseOptions.applicationTypeCode != 'util') {
      data.push({
        name: 'Battery',
        data: [ldata.battery]
      })
    }

    Highcharts.chart('flcoe', {
      chart: {
        type: 'bar'
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: ['LCOE'],
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
          // text: 'Rs. /kWh',
          style: this.cstemapi.h_x_y_title_format
        },
        // labels: {
        //   format: '{value}%'
        // }
      },
      legend: {
        reversed: true
      },
      tooltip: {
        headerFormat: '',
        pointFormat: '<span>{series.name}</span>: <b>{point.y} ({point.percentage:.0f}%)</b><br/>',
        valuePrefix: '₹ ',
        valueSuffix: ' /kWh',
        style: this.cstemapi.h_x_y_tooltip_format
      },
      plotOptions: {
        series: {
          stacking: 'normal'
        }
      },
      series: data
    });
  }

  subsidyChange() {
    if (this.subsidy == '1') {
      this.getCapitalCostSummary();
    }
    if (this.subsidy == '2') {
      this.getLCOESummary();
    }
    if (this.subsidy == '3') {
      this.getIRRSummary();
    }
  }

  getCapitalCostSummary() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId()
    };
    var api = 'fReports/getCapitalCostSummary'
    this.cstemapi.cstemAPI(dObj).GetCapitalCostSummary.subscribe(data => {

      let resData: any = data;
      this.cstemapi.printReqRes(dObj, data, api);
      if (resData.statusCode == 'S001') {
        this.diff = resData.percentageDiff;

        var withsub = {
          category: 'With Subsidy',
          value: (resData.costWithSubsidy.infrastructure + resData.costWithSubsidy.machinery + resData.costWithSubsidy['otherExpenses']).toFixed(2),
          pie: [{
            value: resData.costWithSubsidy.infrastructure.toFixed(2),
            title: 'Infrastructure'
          }, {
            value: resData.costWithSubsidy.machinery.toFixed(2),
            title: 'Machinery'
          }, {
            value: resData.costWithSubsidy['otherExpenses'].toFixed(2),
            title: 'Other Expenses'
          }]
        }
        var withoutsub = {
          category: 'Without Subsidy',
          value: (resData.costWithoutSubsidy.infrastructure + resData.costWithoutSubsidy.machinery + resData.costWithoutSubsidy['otherExpenses']).toFixed(2),
          pie: [{
            value: resData.costWithoutSubsidy.infrastructure.toFixed(2),
            title: 'Infrastructure'
          }, {
            value: resData.costWithoutSubsidy.machinery.toFixed(2),
            title: 'Machinery'
          }, {
            value: resData.costWithoutSubsidy['otherExpenses'].toFixed(2),
            title: 'Other Expenses'
          }]
        }
        this.subsidyChart(withsub, withoutsub);
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting capital cost summary', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  getLCOESummary() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId()
    };
    var api = 'fReports/getLCOESummary'
    this.cstemapi.cstemAPI(dObj).GetLCOESummary.subscribe(data => {

      let resData: any = data;
      this.cstemapi.printReqRes(dObj, data, api);
      if (resData.statusCode == 'S001') {
        this.diff = resData.percentageDiff;

        var withsub = {
          category: 'With Subsidy',
          value: resData.lcoeWithSubsidy.infrastructure + resData.lcoeWithSubsidy.machinery + resData.lcoeWithSubsidy['otherExpenses'] + resData.lcoeWithSubsidy['oAndM'],
          pie: [{
            value: resData.lcoeWithSubsidy.infrastructure,
            title: 'Infrastructure'
          }, {
            value: resData.lcoeWithSubsidy.machinery,
            title: 'Machinery'
          }, {
            value: resData.lcoeWithSubsidy['otherExpenses'],
            title: 'Other Expenses'
          }, {
            value: resData.lcoeWithSubsidy['oAndM'],
            title: 'O&M'
          }]
        }
        var withoutsub = {
          category: 'Without Subsidy',
          value: resData.lcoeWithoutSubsidy.infrastructure + resData.lcoeWithoutSubsidy.machinery + resData.lcoeWithoutSubsidy['otherExpenses'] + resData.lcoeWithoutSubsidy['oAndM'],
          pie: [{
            value: resData.lcoeWithoutSubsidy.infrastructure,
            title: 'Infrastructure'
          }, {
            value: resData.lcoeWithoutSubsidy.machinery,
            title: 'Machinery'
          }, {
            value: resData.lcoeWithoutSubsidy['otherExpenses'],
            title: 'Other Expenses'
          }, {
            value: resData.lcoeWithoutSubsidy['oAndM'],
            title: 'O&M'
          }]
        }
        this.subsidyChart(withsub, withoutsub);
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting lcoe summary details', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  getIRRSummary() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId()
    };
    var api = 'fReports/getIrrSummary'
    this.cstemapi.cstemAPI(dObj).GetIrrSummary.subscribe(data => {

      let resData: any = data;
      this.cstemapi.printReqRes(dObj, data, api);
      if (resData.statusCode == 'S001') {
        var withlcoe = {
          category: 'With LCOE',
          value: resData.withoutSubsidy
        }
        var withBidFit = {};
        if (this.chooseOptions.financialModelTypeCode == 'bid') {
          withBidFit['category'] = 'With Bid';
          withBidFit['value'] = resData.withbidFit
          this.subsidyChart(withlcoe, withBidFit);
        } else if (this.chooseOptions.financialModelTypeCode == 'fit') {
          withBidFit['category'] = 'With FIT';
          withBidFit['value'] = resData.withbidFit
          this.subsidyChart(withlcoe, withBidFit);
        } else {
          this.subsidyChart(withlcoe, withBidFit)
        }

      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting irr summary details', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  subsidyChart(withsub, withoutsub) {
    let un, vm = this;
    if (vm.subsidy == '1') {
      un = '₹ Lakhs';
    } else if (vm.subsidy == '2') {
      un = '₹ / kWh';
    } else {
      un = '%';
    }
    var data = [];

    data = [withsub, withoutsub];

    var chart = am4core.create("fsubsidy", am4charts.XYChart);
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    if (this.auth.getGuestUserId() == '' && this.auth.getIsGuest() == 'true') {
      chart.exporting.menu = new am4core.ExportMenu();
      chart.exporting.filePrefix = this.sheader;
    }
    chart.data = data;

    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.grid.template.disabled = true;

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = un;
    valueAxis.min = 0;
    valueAxis.renderer.baseGrid.disabled = true;
    valueAxis.renderer.grid.template.strokeOpacity = 0.07;

    // Create series
    var series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "value";
    series.dataFields.categoryX = "category";
    series.tooltip.pointerOrientation = "vertical";


    var columnTemplate = series.columns.template;
    // add tooltip on column, not template, so that slices could also have tooltip
    if (vm.subsidy == '1') {
      columnTemplate.column.tooltipText = "{categoryX}\nTotal: ₹ {valueY} Lakhs";
      // un = '₹ Lakhs';
    } else if (vm.subsidy == '2') {
      columnTemplate.column.tooltipText = "{categoryX}\nTotal: ₹ {valueY} / kWh";
      // un = '₹ / kWh';
    } else {
      columnTemplate.column.tooltipText = "{categoryX}\nTotal: {valueY} %";
      // un = '%';
    }
    // columnTemplate.column.tooltipText = "{categoryX}\nTotal: {valueY} ";
    columnTemplate.column.tooltipY = 0;
    columnTemplate.column.cornerRadiusTopLeft = 20;
    columnTemplate.column.cornerRadiusTopRight = 20;
    columnTemplate.strokeOpacity = 0;


    columnTemplate.adapter.add("fill", (fill, target) => {
      var color = chart.colors.getIndex(target.dataItem.index * 3);
      return color;
    });

    // create pie chart as a column child
    var pieChart = series.columns.template.createChild(am4charts.PieChart);
    pieChart.width = am4core.percent(80);
    pieChart.height = am4core.percent(80);
    pieChart.align = "center";
    pieChart.valign = "middle";
    pieChart.dataFields.data = "pie";

    var pieSeries = pieChart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "value";
    pieSeries.dataFields.category = "title";
    pieSeries.labels.template.disabled = true;
    pieSeries.ticks.template.disabled = true;
    pieSeries.slices.template.stroke = am4core.color("#ffffff");
    pieSeries.slices.template.strokeWidth = 1;
    pieSeries.slices.template.strokeOpacity = 0;

    pieSeries.slices.template.adapter.add("fill", (fill, target) => {
      return am4core.color("#ffffff")
    });

    pieSeries.slices.template.adapter.add("fillOpacity", (fillOpacity, target) => {
      return (target.dataItem.index + 1) * 0.2;
    });

    pieSeries.hiddenState.properties.startAngle = -90;
    pieSeries.hiddenState.properties.endAngle = 270;

  }

  scrollToView(id) {
    var elmnt = document.getElementById(id);
    elmnt.scrollIntoView({
      behavior: 'smooth'
    });
  }

  getYearMetrics_base(type) {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId(),
      type: type,
      mode: 'lwos'
    };
    var api = 'fReports/getYearOnYearData'
    this.cstemapi.cstemAPI(dObj).GetYearonYearData.subscribe(data => {

      let resData: any = data;
      this.cstemapi.printReqRes(dObj, data, api);
      if (resData.statusCode == 'S001') {

        if (type == 'netSaleableEnergyMU') {
          var result = resData.data, dset = [];
          for (var i = 0; i < result.length - 1; i++) {
            dset.push({
              name: i + 1,
              y: result[i + 1],
              per: parseFloat(((result[i + 1] / result[1]) * 100).toFixed(2))
            })
          }

          if (dset.length == 25) {
            if (this.chooseOptions.applicationTypeCode != 'util') {
              this.netSalable = {
                name: 'Base case',
                type: 'line',
                unit: 'Thousand Units',
                data: dset,
                valueDecimals: 1
              };
            } else {
              this.netSalable = {
                name: 'Base case',
                type: 'line',
                unit: 'MU',
                data: dset,
                valueDecimals: 1
              };
            }

            // this.yearMetricsChart('fyear', this.netSalable, 0)
          }
        }
        if (type == 'netSaleOfEnergy') {
          var result = resData.data, dset = [];
          for (var i = 0; i < result.length - 1; i++) {
            dset.push({
              name: i + 1,
              y: result[i + 1]
            })
          }
          if (dset.length == 25) {
            this.saleofEnergy = {
              name: 'Base case',
              type: 'line',
              unit: 'Rs.Lakhs',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear1', this.saleofEnergy, 1);

            this.getYearMetrics_base('ebidta');
            this.getYearMetrics_base('pat');

          }
        }
        if (type == 'ebidta') {
          var result = resData.data, dset = [];
          if (this.saleofEnergy.data != 0) {
            for (var i = 0; i < result.length - 1; i++) {
              var sale = this.saleofEnergy.data;
              dset.push({
                name: i + 1,
                y: result[i + 1],
                per: parseFloat(((result[i + 1] / sale[i].y) * 100).toFixed(2))
              })
            }
          }

          if (dset.length == 25) {
            this.ebidta = {
              name: 'Base case',
              type: 'line',
              unit: 'Rs.Lakhs',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear2', this.ebidta, 2)
            // console.log(dset)
          }
        }
        if (type == 'pat') {
          var result = resData.data, dset = [];
          if (this.saleofEnergy.data != 0) {
            for (var i = 0; i < result.length - 1; i++) {
              var sale = this.saleofEnergy.data;
              dset.push({
                name: i + 1,
                y: result[i + 1],
                per: parseFloat(((result[i + 1] / sale[i].y) * 100).toFixed(2))
              })
            }
          }
          if (dset.length == 25) {
            this.pat = {
              name: 'Base case',
              unit: 'Rs.Lakhs',
              data: dset,
              valueDecimals: 1
            };
            setTimeout(() => {
              this.yychange();
            });

            // this.yearMetricsChart('fyear3', this.pat, 3)
            // console.log(dset)
          }
        }
        if (type == 'dscr') {
          var result = resData.data, dset = [];
          for (var i = 0; i < result.length - 1; i++) {
            dset.push({
              name: i + 1,
              y: result[i + 1]
            })
          }
          if (dset.length == 25) {
            this.dscr = {
              name: 'Base case',
              unit: '',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear4', this.dscr, 4)
          }
        }

      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting year on year details', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  getYearMetrics_basews(type) {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId(),
      type: type,
      mode: 'lws'
    };
    var api = 'fReports/getYearOnYearData'
    this.cstemapi.cstemAPI(dObj).GetYearonYearData.subscribe(data => {

      let resData: any = data;
      this.cstemapi.printReqRes(dObj, data, api);
      if (resData.statusCode == 'S001') {

        if (type == 'netSaleableEnergyMU') {
          var result = resData.data, dset = [];
          for (var i = 0; i < result.length - 1; i++) {
            dset.push({
              name: i + 1,
              y: result[i + 1],
              per: parseFloat(((result[i + 1] / result[1]) * 100).toFixed(2))
            })
          }

          if (dset.length == 25) {
            if (this.chooseOptions.applicationTypeCode != 'util') {
              this.netSalable_ws = {
                name: 'Base case with Subsidy',
                type: 'line',
                unit: 'Thousand Units',
                data: dset,
                valueDecimals: 1
              };
            } else {
              this.netSalable_ws = {
                name: 'Base case with Subsidy',
                type: 'line',
                unit: 'MU',
                data: dset,
                valueDecimals: 1
              };
            }

            // this.yearMetricsChart('fyear', this.netSalable, 0)
          }
        }
        if (type == 'netSaleOfEnergy') {
          var result = resData.data, dset = [];
          for (var i = 0; i < result.length - 1; i++) {
            dset.push({
              name: i + 1,
              y: result[i + 1]
            })
          }
          if (dset.length == 25) {
            this.saleofEnergy_ws = {
              name: 'Base case with Subsidy',
              type: 'line',
              unit: 'Rs.Lakhs',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear1', this.saleofEnergy, 1);

            this.getYearMetrics_basews('ebidta');
            this.getYearMetrics_basews('pat');

          }
        }
        if (type == 'ebidta') {
          var result = resData.data, dset = [];
          if (this.saleofEnergy_ws.data != 0) {
            for (var i = 0; i < result.length - 1; i++) {
              var sale = this.saleofEnergy_ws.data;
              dset.push({
                name: i + 1,
                y: result[i + 1],
                per: parseFloat(((result[i + 1] / sale[i].y) * 100).toFixed(2))
              })
            }
          }

          if (dset.length == 25) {
            this.ebidta_ws = {
              name: 'Base case with Subsidy',
              type: 'line',
              unit: 'Rs.Lakhs',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear2', this.ebidta, 2)
            // console.log(dset)
          }
        }
        if (type == 'pat') {
          var result = resData.data, dset = [];
          if (this.saleofEnergy_ws.data != 0) {
            for (var i = 0; i < result.length - 1; i++) {
              var sale = this.saleofEnergy_ws.data;
              dset.push({
                name: i + 1,
                y: result[i + 1],
                per: parseFloat(((result[i + 1] / sale[i].y) * 100).toFixed(2))
              })
            }
          }
          if (dset.length == 25) {
            this.pat_ws = {
              name: 'Base case with Subsidy',
              unit: 'Rs.Lakhs',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear3', this.pat, 3)
            // console.log(dset)
          }
        }
        if (type == 'dscr') {
          var result = resData.data, dset = [];
          for (var i = 0; i < result.length - 1; i++) {
            dset.push({
              name: i + 1,
              y: result[i + 1]
            })
          }
          if (dset.length == 25) {
            this.dscr_ws = {
              name: 'Base case with Subsidy',
              unit: '',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear4', this.dscr, 4)
          }
        }

      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting year on year details', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  getYearMetrics_bidfit(type, mode) {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId(),
      type: type,
      mode: mode
    };

    var fb;
    if (mode == 'bidMode') {
      fb = 'Bid'
    } else {
      fb = 'FIT'
    }
    // console.log(JSON.stringify(dObj))
    var api = 'fReports/getYearOnYearData'

    this.cstemapi.cstemAPI(dObj).GetYearonYearData.subscribe(data => {

      let resData: any = data;
      this.cstemapi.printReqRes(dObj, data, api);
      if (resData.statusCode == 'S001') {

        if (type == 'netSaleableEnergyMU') {
          var result = resData.data, dset = [];
          for (var i = 0; i < result.length - 1; i++) {
            dset.push({
              name: i + 1,
              y: result[i + 1],
              per: parseFloat(((result[i + 1] / result[1]) * 100).toFixed(2))
            })
          }

          if (dset.length == 25) {
            this.netSalable_bf = {
              name: fb,
              type: 'line',
              unit: 'MU',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear', this.netSalable, 0)
          }
        }
        if (type == 'netSaleOfEnergy') {
          var result = resData.data, dset = [];
          for (var i = 0; i < result.length - 1; i++) {
            dset.push({
              name: i + 1,
              y: result[i + 1]
            })
          }
          if (dset.length == 25) {
            this.saleofEnergy_bf = {
              name: fb,
              type: 'line',
              unit: 'Rs.Lakhs',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear1', this.saleofEnergy, 1);

            this.getYearMetrics_bidfit('ebidta', mode);
            this.getYearMetrics_bidfit('pat', mode);

          }
        }
        if (type == 'ebidta') {
          var result = resData.data, dset = [];
          if (this.saleofEnergy_bf.data != 0) {
            for (var i = 0; i < result.length - 1; i++) {
              var sale = this.saleofEnergy_bf.data;
              dset.push({
                name: i + 1,
                y: result[i + 1],
                per: parseFloat(((result[i + 1] / sale[i].y) * 100).toFixed(2))
              })
            }
          }

          if (dset.length == 25) {
            this.ebidta_bf = {
              name: fb,
              type: 'line',
              unit: 'Rs.Lakhs',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear2', this.ebidta, 2)
            // console.log(dset)
          }
        }
        if (type == 'pat') {
          var result = resData.data, dset = [];
          if (this.saleofEnergy_bf.data != 0) {
            for (var i = 0; i < result.length - 1; i++) {
              var sale = this.saleofEnergy_bf.data;
              dset.push({
                name: i + 1,
                y: result[i + 1],
                per: parseFloat(((result[i + 1] / sale[i].y) * 100).toFixed(2))
              })
            }
          }
          if (dset.length == 25) {
            this.pat_bf = {
              name: fb,
              unit: 'Rs.Lakhs',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear3', this.pat, 3)
            // console.log(dset)
          }
        }
        if (type == 'dscr') {
          var result = resData.data, dset = [];
          for (var i = 0; i < result.length - 1; i++) {
            dset.push({
              name: i + 1,
              y: result[i + 1]
            })
          }
          if (dset.length == 25) {
            this.dscr_bf = {
              name: fb,
              unit: '',
              data: dset,
              valueDecimals: 1
            };
            // this.yearMetricsChart('fyear4', this.dscr, 4)
          }
        }

      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting year on year details', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  yychange() {
    if (this.basecase && this.basecase_ws && this.bidfitcase) {
      this.yearMetricsChart_new('fyear', [this.getObj(this.netSalable, 0), this.getObj(this.netSalable_ws, 0), this.getObj(this.netSalable_bf, 0)]);
      this.yearMetricsChart_new('fyear1', [this.getObj(this.saleofEnergy, 1), this.getObj(this.saleofEnergy_ws, 1), this.getObj(this.saleofEnergy_bf, 1)]);
      this.yearMetricsChart_new('fyear2', [this.getObj(this.ebidta, 2), this.getObj(this.ebidta_ws, 2), this.getObj(this.ebidta_bf, 2)]);
      this.yearMetricsChart_new('fyear3', [this.getObj(this.pat, 3), this.getObj(this.pat_ws, 3), this.getObj(this.pat_bf, 3)]);
      this.yearMetricsChart_new('fyear4', [this.getObj(this.dscr, 4), this.getObj(this.dscr_ws, 4), this.getObj(this.dscr_bf, 4)]);
    } else if (this.basecase && this.basecase_ws) {
      this.yearMetricsChart_new('fyear', [this.getObj(this.netSalable, 0), this.getObj(this.netSalable_ws, 0)]);
      this.yearMetricsChart_new('fyear1', [this.getObj(this.saleofEnergy, 1), this.getObj(this.saleofEnergy_ws, 1)]);
      this.yearMetricsChart_new('fyear2', [this.getObj(this.ebidta, 2), this.getObj(this.ebidta_ws, 2)]);
      this.yearMetricsChart_new('fyear3', [this.getObj(this.pat, 3), this.getObj(this.pat_ws, 3)]);
      this.yearMetricsChart_new('fyear4', [this.getObj(this.dscr, 4), this.getObj(this.dscr_ws, 4)]);
    } else if (this.basecase && this.bidfitcase) {
      this.yearMetricsChart_new('fyear', [this.getObj(this.netSalable, 0), this.getObj(this.netSalable_bf, 0)]);
      this.yearMetricsChart_new('fyear1', [this.getObj(this.saleofEnergy, 1), this.getObj(this.saleofEnergy_bf, 1)]);
      this.yearMetricsChart_new('fyear2', [this.getObj(this.ebidta, 2), this.getObj(this.ebidta_bf, 2)]);
      this.yearMetricsChart_new('fyear3', [this.getObj(this.pat, 3), this.getObj(this.pat_bf, 3)]);
      this.yearMetricsChart_new('fyear4', [this.getObj(this.dscr, 4), this.getObj(this.dscr_bf, 4)]);

    } else if (this.basecase_ws) {
      this.yearMetricsChart_new('fyear', [this.getObj(this.netSalable_ws, 0)])
      this.yearMetricsChart_new('fyear1', [this.getObj(this.saleofEnergy_ws, 1)])
      this.yearMetricsChart_new('fyear2', [this.getObj(this.ebidta_ws, 2)])
      this.yearMetricsChart_new('fyear3', [this.getObj(this.pat_ws, 3)])
      this.yearMetricsChart_new('fyear4', [this.getObj(this.dscr_ws, 4)])
    } else if (this.bidfitcase) {
      this.yearMetricsChart_new('fyear', [this.getObj(this.netSalable_bf, 0)])
      this.yearMetricsChart_new('fyear1', [this.getObj(this.saleofEnergy_bf, 1)])
      this.yearMetricsChart_new('fyear2', [this.getObj(this.ebidta_bf, 2)])
      this.yearMetricsChart_new('fyear3', [this.getObj(this.pat_bf, 3)])
      this.yearMetricsChart_new('fyear4', [this.getObj(this.dscr_bf, 4)])
    } else if (this.basecase) {
      // console.log(this.netSalable)
      this.yearMetricsChart_new('fyear', [this.getObj(this.netSalable, 0)])
      this.yearMetricsChart_new('fyear1', [this.getObj(this.saleofEnergy, 1)])
      this.yearMetricsChart_new('fyear2', [this.getObj(this.ebidta, 2)])
      this.yearMetricsChart_new('fyear3', [this.getObj(this.pat, 3)])
      this.yearMetricsChart_new('fyear4', [this.getObj(this.dscr, 4)])
    }
  }

  yearMetricsChart_new(id, dset) {
    // console.log(dset);
    var un;
    if (dset[0].unit == 'Rs.Lakhs') {
      un = '₹ Lakhs'
    } else {
      un = dset[0].unit;
    }
    Highcharts.chart(id, {
      chart: {
        type: 'line',
        // marginLeft: 80, // Keep all charts left aligned
        // spacingTop: 20,
        // spacingBottom: 20
      },
      title: {
        text: '',
        // align: 'left',
        // margin: 0,
        // x: 30
      },
      xAxis: {
        tickInterval: 1,
        categories: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25'],
        title: {
          text: 'Year',
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      // credits: {
      //   enabled: false
      // },
      legend: {
        enabled: false
      },
      // exporting: { enabled: false },
      yAxis: {
        title: {
          text: un,
          style: this.cstemapi.h_x_y_title_format,
          // margin: 30
        },
        labels: {
          // format: '{value:.3f}',
          style: this.cstemapi.h_x_y_format
        }
      },
      tooltip: {
        shared: true,
        crosshairs: true,
        headerFormat: '<b>{point.key}</b><br/>',
        style: this.cstemapi.h_x_y_tooltip_format,

        pointFormatter: function () {
          var point = this;
          if (point.per) {
            if (dset[0].unit == 'Rs.Lakhs') {
              return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>₹ ' + point.y + ' Lakhs, (' + point.per + ' %)' + '</b><br/>';
            } else {
              return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b> ' + point.y + ' ' + dset[0].unit + ', (' + point.per + ' %)' + '</b><br/>';
            }
          } else {
            if (dset[0].unit == 'Rs.Lakhs') {
              return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>₹ ' + point.y + ' Lakhs' + '</b><br/>';
            } else {
              return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b> ' + point.y + ' ' + dset[0].unit + '</b><br/>';
            }
          }
        },
      },
      series: dset
    });
  }

  getObj(dset, color) {
    return {
      data: dset.data,
      name: dset.name,
      type: dset.type,
      unit: dset.unit
      // color: Highcharts.getOptions().colors[color]
    }
  }
}
